const Sides = () => {
	return <div>Sides</div>;
};
export default Sides;
